var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApprove = function SvgApprove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.328 1.893c-3.575 0-6.5 2.925-6.5 6.5s2.925 6.5 6.5 6.5 6.5-2.925 6.5-6.5-2.925-6.5-6.5-6.5m2.73 5.395-3.12 3.12c-.26.26-.65.26-.91 0l-1.43-1.43a.63.63 0 0 1 0-.91c.26-.26.65-.26.91 0l.975.975 2.665-2.665c.26-.26.65-.26.91 0s.26.65 0 .91"
  })));
};
export default SvgApprove;